<template>
  <div class="t-mt-4">
    <paginate
      v-if="trackers && pagination"
      :page-count="pagination.pageCount"
      :page-range="pagination.pageRange"
      :margin-pages="pagination.marginPages"
      :click-handler="changePage"
      :prev-text="'&laquo;'"
      :next-text="'&raquo;'"
      :prev-link-class="'page-link'"
      :next-link-class="'page-link'"
      :container-class="'pagination'"
      :page-class="'page-item'"
      :page-link-class="'page-link'"
      class="t-flex t-justify-end t-mb-4"
    />

    <div
      :class="{
        'md:t-grid-cols-6': columnHeaders.length === 6,
        'md:t-grid-cols-7': columnHeaders.length === 7
      }"
      class="t-hidden t-px-3 md:t-grid md:t-grid-rows-1 md:t-gap-x-4"
    >
      <div
        v-for="(columnHeader, index) in columnHeaders"
        :key="index"
        class="t-text-left t-text-xs t-font-medium t-tracking-wider"
      >
        {{ columnHeader }}
      </div>
    </div>

    <div
      v-if="paginatedTrackers"
      v-for="tracker in paginatedTrackers"
      :key="tracker.id"
      class="t-px-3 t-py-3 t-border t-border-gray-300 t-rounded-lg t-shadow-lg t-gap-x-4 t-mb-4 t-bg-white lg:t-py-0"
    >
      <div
        :class="{
          't-grid-rows-6 md:t-grid-cols-6': columnHeaders.length === 6,
          't-grid-rows-7 md:t-grid-cols-7': columnHeaders.length === 7
        }"
        class="t-grid t-grid-cols-1 md:t-grid-rows-1 md:t-gap-x-2"
      >
        <div class="lg:t-py-4">
          <div
            class="t-grid t-grid-rows-1 t-grid-cols-2 t-visible t-block md:t-hidden"
          >
            <p>Freightmate</p>
            <p v-if="tracker.id">
              {{ tracker.id.toString().substring(4) }}
            </p>
          </div>
          <p class="t-hidden md:t-inline" v-if="tracker.id">
            {{ tracker.id.toString().substring(4) }}
          </p>
        </div>

        <slot name="asset" :assetName="tracker.assetName"></slot>

        <slot name="location" :tracker="tracker"></slot>

        <slot name="recipient" :tracker="tracker"></slot>

        <div class="t-text-sm lg:t-py-4">
          <div
            class="t-grid t-grid-rows-1 t-grid-cols-2 t-visible t-block md:t-hidden"
          >
            <div>Last Detected</div>
            <div>
              <span v-if="tracker.updatedAt === ''">N/A</span>
              <span v-else>{{ tracker.updatedAt.fromNow() }}</span>
            </div>
          </div>

          <div class="t-hidden md:t-block">
            <span v-if="tracker.updatedAt === ''">N/A</span>
            <span v-else>{{ tracker.updatedAt.fromNow() }}</span>
          </div>
        </div>

        <div class="t-text-sm lg:t-py-4">
          <div
            class="t-grid t-grid-rows-1 t-grid-cols-2 t-visible t-block md:t-hidden"
          >
            <div>Last Movement</div>
            <div>
              <span v-if="tracker.unlinkedAt === ''">N/A</span>
              <span v-else>{{ tracker.unlinkedAt.fromNow(true) }} ago</span>
            </div>
          </div>

          <div class="t-hidden md:t-block">
            <span v-if="tracker.unlinkedAt === ''">N/A</span>
            <span v-else>{{ tracker.unlinkedAt.fromNow(true) }} ago</span>
          </div>
        </div>

        <slot name="booking" :bookingId="tracker.bookingId"></slot>

        <slot name="options" :tracker="tracker"></slot>

        <div class="t-flex t-justify-center t-items-center t-text-sm">
          <freight-mate-movements-map
            :tracker-id="parseInt(tracker.id)"
            :asset-name="tracker.assetName"
          >
            <template>
              <p
                class="t-font-bold t-bg-blue-500 t-text-white t-text-center t-rounded t-px-2 t-py-1 t-mb-0
                lg:t-text-base hover:t-bg-blue-700"
              >
                View Map
              </p>
            </template>
          </freight-mate-movements-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import FreightMateMovementsMap from "../../modals/FreightMateMovementsMap";

export default {
  name: "BaseTrackingTable",
  description: "",
  components: {
    Paginate,
    FreightMateMovementsMap
  },
  props: {
    trackers: {
      type: Array,
      required: true
    },
    columnHeaders: {
      type: Array
    },
    filters: {}
  },
  data() {
    return {
      paginatedTrackers: [],
      pagination: null,
      selectedTrackerId: null
    };
  },
  methods: {
    changePage(page) {
      if (page === this.pagination.pageCount) {
        // Last page
        this.paginatedTrackers = this.trackers.slice(
          this.pagination.itemsPerPage * (page - 1),
          this.trackers.length
        );
      } else {
        this.paginatedTrackers = this.trackers.slice(
          this.pagination.itemsPerPage * (page - 1),
          this.pagination.itemsPerPage * (page - 1) +
            this.pagination.itemsPerPage
        );
      }
    }
  },
  watch: {
    trackers: function() {
      // Set to page 1 as soon as the trackers load
      this.pagination = {
        itemsPerPage: 10,
        pageCount: Math.ceil(this.trackers.length / 10),
        pageRange: 2,
        marginPages: 1
      };
      this.changePage(1);
    }
  }
};
</script>

<style scoped>
p {
  margin: 0;
}
</style>
